export default __webpack_public_path__ + "static/media/GenieMen.3b8183ed.png";